import { GLOBAL_COMMON_LOGS_ENV, LogEnv } from './env.mjs';

const throwErrorIfSSR = () => {
  if (typeof window === 'undefined' && GLOBAL_COMMON_LOGS_ENV.env === LogEnv.dev) {
    throw new Error('window 객체가 없습니다. 해당 함수는 반드시 client-side 에서 실행되어야 합니다.');
  }
};
var throwErrorIfSSR$1 = throwErrorIfSSR;

export { throwErrorIfSSR$1 as default };
